import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IDashboardPostJobClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Post a Job" from the Dashboard
 * Event: dental_portal:dashboard:post_job_clicked
 */
export function fireDashboardPostJobClicked(payload: IDashboardPostJobClickedPayload): void {
  PosthogService.getInstance().track('dental_portal:dashboard:post_job_clicked', {
    posting_id: payload.postingId,
  });
}